import Page from '../page';

import { toggleActive } from '../../lib/inview';


export default class WorksManager extends Page {
	constructor() {
		super();
	}
	init() {
		//console.log("about");
		//gradient(this);
		//dot(this);

		this.scroll();
		this.resize();
		window.dispatchEvent(new Event('resize'));


		toggleActive(document.querySelectorAll(".worksList li"));
		toggleActive(document.querySelectorAll(".categoryNavEach"));

	}
	scroll() {

	}
	resize() {
		window.addEventListener('resize', function (e) {

		})
	}
}